import React from "react";
import type { GetRef, SelectProps } from "antd";

import { Select } from "antd";
import { useTranslation } from "react-i18next";

type Props = Pick<SelectProps, "id" | "aria-describedby" | "aria-invalid" | "aria-required" | "onBlur" | "onFocus"> & {
  value?: string;
  onChange?: (value?: string) => void;
  disabled?: boolean;
};

export const transportationTypeOptionsKeys = [
  "air_delivery_fob",
  "air_fence_exw_fca",
  "air_door_to_door",
  "air_transportation",
  "car_delivery_from_stantion",
  "car_railway",
  "car_sea",
  "car_sea_car",
  "car_transportation",
  "car_transportation_container",
  "car_transportation_danger_in_tank",
  "railway",
  "railway_thermos_wagon",
  "railway_car",
  "railway_delivery_fob",
  "railway_fence_exw_fca",
  "railway_door_to_door",
  "railway_wagon",
  "railway_transportation_container",
  "railway_sea",
  "fence_sea_railway_car",
  "services_organizing_delegation_visit",
  "services_for_equipment_support",
  "buy_sell",
  "sea",
  "sea_delivery",
  "sea_railway",
  "sea_railway_car",
  "sea_railway_delivery",
  "sea_railway_fence",
  "sea_railway_door_to_door",
  "sea_fence",
  "sea_sea",
  "sea_door_to_door",
  "sea_car",
  "river_sea_car",
  "river_sea_railway",
  "terminal_processing_car",
  "techimport",
  "warehouse_storage_sevices",
  "customs_clearance_services",
  "exporting_in_terminals",
  "car_transportation_2",
] as const;

const TransportationTypePicker = React.memo(
  React.forwardRef<GetRef<typeof Select>, Props>(function TransportationTypePicker({ disabled, onChange, value, ...selectProps }, ref) {
    const { t } = useTranslation("translations");
    const options = React.useMemo(() => transportationTypeOptionsKeys.map((key) => ({ value: t(key, { lng: "ru" }), label: t(key) })), [t]);

    return (
      <Select
        {...selectProps}
        ref={ref}
        placeholder={t("transportation_type")}
        value={value}
        options={options}
        onChange={onChange}
        allowClear
        disabled={disabled}
        showSearch={{ optionFilterProp: "label" }}
        style={{ width: "100%" }}
      />
    );
  }),
);

export default TransportationTypePicker;
